/**
 * START GENAI@GHCOPILOT
 * Generates a unique session ID for the VSB SDK.
 * @returns A string representing the session ID.
 * END GENAI@GHCOPILOT
 */
export default function createSessionId() {
  return `vsb_prod_001${Math.random().toString(36).substring(7)}`;
}
